import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import RiderFilter from "./RiderFilter";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IFilterRider } from "../../types/interface";
import { useSessionStorage } from "@uidotdev/usehooks";
const RiderInvoice = () => {
  const navigate = useNavigate();
  const [localState, handleSetState] = useSessionStorage<IFilterRider>(
    "rider-invoice-filter",
    {
      created__range: null,
      driver: null,
      status__in: null,
      user: null,
    }
  );
  const [isFilterVisible, setFilterVisiable] = useState(false);
  const { setValue, getValues, watch, reset, control } = useForm<IFilterRider>({
    defaultValues: async () => ({
      created__range: localState?.created__range ?? null,
      driver: localState?.driver ?? null,
      status__in: localState?.status__in ?? null,
      user: localState?.user ?? null,
    }),
  });
  const handleFilterReset = () => {
    reset({
      created__range: null,
      driver: null,
      status__in: null,
      user: null,
    });
  };
  const defaultColumns: any = useMemo(() => {
    return [
      {
        header: "Statement ID",
        accessorKey: "invoice_id",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              <button
                className={tw`cursor-pointer whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                onClick={() => navigate(`preview/${row?.original?.id}`)}
              >
                {getValue() ?? "N/A"}
              </button>
              {/* <p className="text-xs text-gray-500">
              {moment(row?.original?.created).format("YY-MM-DD HH:mm:ss")}
            </p> */}
            </>
          );
        },
      },
      {
        header: "Date Range",
        accessorKey: "date_range",
        cell: ({ getValue }: any) => {
          const value = getValue();
          if (!value) return <p className={tw`whitespace-nowrap`}>N/A</p>;

          try {
            const parsed = JSON.parse(value);
            const from = parsed?.lower
              ? moment(parsed.lower).format("YYYY-MM-DD")
              : "N/A";
            const to = parsed?.upper
              ? moment(parsed.upper).format("YYYY-MM-DD")
              : "N/A";

            return (
              <p className={tw`whitespace-nowrap`}>
                {from}
                <span className={tw`mx-1`}>-</span>
                {to}
              </p>
            );
          } catch (e) {
            return <p className={tw`whitespace-nowrap`}>N/A</p>;
          }
        },
      },
      {
        header: "Rider Name",
        accessorKey: "user.full_name",
        cell: NACell,
      },
      {
        header: "Amount",
        accessorKey: "invoice_amount",
        cell: ({ getValue }: any) => {
          return (
            <>
              <p className={tw`whitespace-nowrap`}>{getValue() ?? 0.0}</p>
            </>
          );
        },
      },
      {
        header: "Commission",
        accessorKey: "commission",
        cell: ({ getValue }: any) => {
          return (
            <>
              <p className={tw`whitespace-nowrap`}>{getValue() ?? 0.0}</p>
            </>
          );
        },
      },
      {
        header: "Paid Date",
        accessorKey: "settlement_date",
        cell: ({ getValue }: any) => {
          return (
            <p className={tw`text-sm whitespace-nowrap `}>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          );
        },
      },
      {
        header: "payment Remarks",
        accessorKey: "remarks",
        cell: NACell,
      },
      {
        header: "Status",
        accessorKey: "status",
        cell: ({ getValue }: any) => {
          return (
            <>
              <p className={tw`whitespace-nowrap uppercase`}>{getValue()}</p>
            </>
          );
        },
      },
    ];
  }, []);

  const filterParams = watch();

  useEffect(() => {
    const newState = {
      ...localState,
      ...filterParams,
      status__in:
        filterParams?.status__in?.map((status) => ({
          ...status,
          id: status.value,
          name: status.label,
        })) || null,
      user:
        filterParams?.driver?.user?.id ?? filterParams?.driver?.user ?? null,
    };

    const isStateChanged =
      JSON.stringify(localState) !== JSON.stringify(newState);
    if (isStateChanged) {
      handleSetState(newState);
    }

    // Update form value only if different
    const currentValue =
      filterParams?.driver?.user?.id ?? filterParams?.driver?.user ?? null;
    if (getValues("user") !== currentValue) {
      setValue("user", currentValue);
    }
  }, [filterParams, setValue, localState, getValues]);

  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  return (
    <>
      <Card title="Filters" onClick={() => setFilterVisiable(!isFilterVisible)}>
        <RiderFilter
          isFilterVisible={isFilterVisible}
          setValue={setValue}
          getValues={getValues}
          handleFilterReset={handleFilterReset}
          control={control}
        />
      </Card>

      <DataTable
        url={APIS.RIDER_INVOICE}
        queryKey={"Rider Invoice"}
        columns={defaultColumns}
        addNewPagePath={"/create"}
        tableName={"rider-invoice"}
        orderSearch={true}
        params={params()}
      />
    </>
  );
};

export default RiderInvoice;
